export const calculateDuration = (startTime?: string, endTime?: string): number => {
    if (!startTime || !endTime) {
        return 0; // safe fallback
    }

    try {
        const start = new Date(startTime);
        const end = new Date(endTime);
        console.log(startTime, end, 'startEnd');
        
        let diffMs = end.getTime() - start.getTime();
        if (diffMs < 0) {
            diffMs += 24 * 60 * 60 * 1000; // handle next day
        }

        return diffMs; // return milliseconds
    } catch (error) {
        console.error('Error calculating duration:', error);
        return 0;
    }
};

export const formatSmartDuration = (milliseconds?: number) => {
    if (!milliseconds || isNaN(milliseconds)) return 'N/A'; // ✅ Handle 0, undefined, NaN safely

    const totalSeconds = Math.floor(milliseconds / 1000);

    if (totalSeconds < 60) {
        return `${totalSeconds} sec`;
    }

    const totalMinutes = Math.floor(totalSeconds / 60);

    if (totalMinutes < 60) {
        return `${totalMinutes} min`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (minutes === 0) {
        return `${hours} hr`;
    }

    return `${hours} hr ${minutes} min`;
};
